import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ButtonGroup from 'reactstrap/es/ButtonGroup';
import Button from 'reactstrap/es/Button';
import classNames from 'classnames';
import { ButtonDatePicker } from './buttonDatePicker';
export function SelectDateButtonGroup({ preconfiguredPeriods, currentPeriod, setPeriod, setCustomPeriod }) {
    return (_jsxs(ButtonGroup, { children: [preconfiguredPeriods.map((periodProps, index) => (_jsx(Button, Object.assign({ color: currentPeriod === index ? 'dark' : 'secondary', className: classNames({ active: currentPeriod === index }), onClick: () => setPeriod(index) }, { children: periodProps.name })))), _jsx(ButtonDatePicker, { isActive: currentPeriod === -1, onChange: setCustomPeriod })] }));
}
